
import { Component, Prop, Vue } from 'vue-property-decorator';
import LoyaltyCertAddForm from '@/form/loyalty/loyaltyCert/LoyaltyCertAddForm';
import FormGroup from '@/UI/components/common/form/FormGroup.vue';
@Component({
    components: { FormGroup }
})
export default class LoyaltyCertAddComponent extends Vue {
    @Prop() readonly form!: LoyaltyCertAddForm;
    constructor() {
        super();
    }
}
